import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import filters from '@/filters'
import i18n from '@/services/i18n'
import Toast from '@/plugins/toast'
import DynamicAssign from '@/plugins/dynamicAssign'
import { Currency } from '@/components'

Vue.config.productionTip = false

Vue.use(filters)
Vue.use(Toast)
Vue.use(DynamicAssign)

new Vue({
   store,
   router,
   i18n,
   components: {
      Currency,
   },
   render: h => h(App),
}).$mount('#app')
